import type { Member } from '@wix/ambassador-blog-frontend-adapter-public-v2-post-feed-page/types';
import { createAction, GLOBALS } from '@wix/communities-blog-client-common';
import type { FeedPageThunkAction } from '@app/external/feed-page/types';
import { createPromisifiedAction } from '../../actions-promisifier/create-promisified-action';
import { blogAppDefId } from '../../constants/apps';
import { initializeInstanceValues } from '../instance-values/instance-values-actions';

export const fetchCurrentUserRequest = createAction('currentUser/FETCH_REQUEST');
export const fetchCurrentUserSuccess = createAction(
  'currentUser/FETCH_SUCCESS',
  (payload: Member) => payload,
);
export const fetchCurrentUserFailure = createAction('currentUser/FETCH_FAILURE');

export const fetchCurrentUser =
  (tokenToPreviewPost?: string): FeedPageThunkAction<Promise<void>> =>
  async (dispatch, _, { httpClient, errorHandler, platformApi }) => {
    const { withErrorHandler, getResolvedError } = errorHandler;
    dispatch(fetchCurrentUserRequest());

    try {
      const token = tokenToPreviewPost ?? platformApi.site.getAppToken?.(blogAppDefId);

      dispatch(initializeInstanceValues(token));

      const response = await withErrorHandler(
        () =>
          httpClient.get<Member>(`${GLOBALS.API_BASE_URL_CLIENT}/_api/users/current`, {
            headers: {
              instance: token,
              Authorization: token,
            },
          }),
        {
          errorCodesMap: {},
        },
      );

      dispatch(fetchCurrentUserSuccess(response.data));
    } catch (error) {
      dispatch(fetchCurrentUserFailure());
      getResolvedError(error);
    }
  };

export const fetchCurrentUserPromisified = createPromisifiedAction(
  fetchCurrentUser,
  (result) => result,
);
